<template>
  <div>
    <canvas ref="canvas" @click="handleClick"></canvas>
    <div id="canvasOverlay" class="overlay clickthroug" @click="next">
      <div class="subtitles">{{ subtitles }}</div>
    </div>
  </div>
</template>

<script>
import { Ludwig } from "../classes/ludwig.js";
import { Scene } from "../classes/scene.js";
import { Prop } from "../classes/props.js";
import { mapGetters } from "vuex";

export default {
  name: "CanvasComponent",
  props: ["inventoryClicked"],
  data() {
    return {
      ludwig: null,
      ctx: null,
      relation: 1,
      props: [],
      action: null,
      propPos: [],
      prohibited: [
        [
          { x: 0.0, y: 1080.0 },
          { x: 170.83, y: 966.48 },
          { x: 289.33, y: 934.53 },
          { x: 318.62, y: 934.53 },
          { x: 624.83, y: 720.18 },
          { x: 768.62, y: 720.18 },
          { x: 768.62, y: 773.43 },
          { x: 781.93, y: 774.76 },
          { x: 792.59, y: 847.99 },
          { x: 1136.08, y: 847.99 },
          { x: 1148.06, y: 769.44 },
          { x: 1170.7, y: 766.77 },
          { x: 1182.68, y: 720.18 },
          { x: 1265.22, y: 720.18 },
          { x: 1439.63, y: 942.52 },
          { x: 1522.18, y: 993.0 },
          { x: 1630.02, y: 1009.08 },
          { x: 1771.81, y: 1013.74 },
          { x: 1920.0, y: 1080.0 },
          { x: 1920.0, y: 0.0 },
          { x: 0.0, y: 0.0 },
        ],
      ],
    };
  },
  watch: {
    lastTaken(item) {
      // wenn sich `lastTaken` ändert.
      this.removeProp(item);
      this.ludwig.take();
    },
    playerNext() {
      this.next();
    },
    inventoryClicked(actions) {
      if (actions) {
        this.action = actions;
        if (this.userCommand == "b") {
          //benutze mit
        } else {
          this.startAction(); //start action immediately
        }
      }
    },
  },
  mounted() {
    this.initCanvas();
    this.setRelation();
  },
  computed: {
    ...mapGetters([
      "conditions",
      "items",
      "userCommand",
      "waitingForMo",
      "line",
      "lastTaken",
      "playerNext",
      "currentLine",
      "userCombineWith",
      // ...
    ]),
    subtitles() {
      if (this.waitingForMo) {
        return this.line;
      }
      return "";
    },
  },

  methods: {
    onResize() {
      this.setRelation();
    },
    setRelation() {
      this.relation = this.$refs.canvas.offsetWidth / 1920;
      console.log(this.relation);
    },
    initCanvas() {
      const canvas = this.$refs.canvas;
      //CanvasRenderingContext2D.prototype.clip = function () { };
      this.ctx = canvas.getContext("2d");
      canvas.width = 1920; // Setze die gewünschte Breite
      canvas.height = 1080; // Setze die gewünschte Höhe

      // Grundlegende Zeichnung
      this.ctx.fillStyle = "Magenta";
      this.ctx.fillRect(0, 0, canvas.width, canvas.height);

      this.scene = new Scene(this.ctx, this.relation, this.prohibited); // Startposition
      this.ludwig = new Ludwig(
        100,
        500,
        this.relation,
        this.ctx,
        this.scene.nogo
      ); // Startposition
      this.setupProps();
      this.wait(100).then(() => {
        this.redraw();
      });
    },
    setupProps() {
      this.props = [];
      Object.entries(this.items).forEach(([key, item]) => {
        if ("coordinates" in item) {
          let _item = new Prop(item.text, key, this.relation, item.coordinates);
          this.props.push(_item);
        }
      });
    },
    handleClick(e) {
      const x = e.offsetX;
      const y = e.offsetY;
      console.log(x, y);

      if (!this.checkAreas(x, y) && !this.scene.isProhibited(x, y)) {
        this.action = null;
        this.ludwig.stop();
        this.ludwig.moveTo(x, y);
        this.animate();
      }
    },
    checkAreas(x, y) {
      //check if prop is clicked
      let ludwigIsChecked = false;
      for (let p of this.props) {
        if (p.depth < this.ludwig.depth) {
          if (this.isProp(p, x, y)) {
            return true;
          }
        }
        if (!ludwigIsChecked) {
          if (
            this.isLudwig(
              { x: x, y: y },
              this.ludwig.polygon,
              {
                x: this.ludwig.xPos + this.ludwig.trueImgSize.offsetX,
                y: this.ludwig.yPos + this.ludwig.trueImgSize.offsetY,
              },
              {
                height: this.ludwig.trueImgSize.height,
                width: this.ludwig.trueImgSize.width,
              }
            )
          ) {
            if (!this.userCommand) {
              // Ludwig weiss nicht was er genau damit tu soll
            } else {
              let actions;
              if (this.userCombineWith) {
                if ("ludwig" in this.items[this.userCombineWith].actions.c) {
                  actions = this.items[this.userCombineWith].actions.c.ludwig;
                } else {
                  actions = this.items[this.userCombineWith].actions.c.default;
                }
              } else {
                actions = this.items.ludwig.actions[this.userCommand];
              }
              this.$store.commit("userCombineWith", null);
              this.action = actions;
              this.startAction(); //start action immediately
            }
            return true;
          } else {
            ludwigIsChecked = true;
          }
        }
        if (p.depth >= this.ludwig.depth) {
          if (this.isProp(p, x, y)) {
            return true;
          }
        }
      }
      return false;
    },
    isProp(p, x, y) {
      if (this.ctx.isPointInPath(p.area, x, y)) {
        //check if clicked point is inside prohibited area
        console.log("hit", p.name);
        this.ludwig.stop();
        this.ludwig.moveTo(p.xMoveto, p.yMoveto);
        this.animate();

        if (!this.userCommand) {
          // Ludwig weiss nicht was er genau damit tu soll
        } else {
          if (this.userCombineWith) {
            console.log("combine with");
            this.combineWithItem(p.id);
          } else {
            this.action = this.items[p.id].actions[this.userCommand];
          }
          this.propPos = p.pos;
        }
        return true;
      }
    },
    isLudwig(point, polygon, position, size) {
      let x = point.x;
      let y = point.y;

      let inside = false;
      for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        // Umrechnung der relativen Koordinaten in absolute Pixelkoordinaten
        let xi = polygon[i].x * size.width + position.x,
          yi = polygon[i].y * size.height + position.y;
        let xj = polygon[j].x * size.width + position.x,
          yj = polygon[j].y * size.height + position.y;

        let intersect =
          yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
        if (intersect) inside = !inside;
      }

      return inside;
    },
    combineWithItem(item) {
      if (item in this.items[this.userCombineWith].actions.c) {
        this.action = this.items[this.userCombineWith].actions.c[item];
      } else {
        this.action = this.items[this.userCombineWith].actions.c.default;
        console.log(this.items[this.userCombineWith].actions.c.default);
      }
      this.$store.commit("userCombineWith", null);
    },
    // Hier kannst du Logik hinzufügen, um auf Klicks zu reagieren
    drawProp(prop) {
      if (prop.image) {
        this.ctx.drawImage(
          prop.image,
          prop.xPos,
          prop.yPos,
          prop.width,
          prop.height
        );
      }
    },
    removeProp(item) {
      let indexToRemove = -1;

      for (let i = 0; i < this.props.length; i++) {
        if (this.props[i].id == item) {
          indexToRemove = i;
          break; // Beende die Schleife, sobald das Element gefunden wurde
        }
      }

      if (indexToRemove !== -1) {
        this.props.splice(indexToRemove, 1); // Entferne das Element
      }
      this.redraw();
    },
    animate() {
      this.ludwig.move(this.scene.prohibited);
      this.redraw();
      if (this.ludwig.moving) {
        //stop when at destination
        if (this.ludwig.gameFrame % 10 === 0) {
          if (this.ludwig.frameX < 11) this.ludwig.frameX++;
          else this.ludwig.frameX = 0;
        }
        this.ludwig.gameFrame++;
        
        this.ludwig.animation = requestAnimationFrame(this.animate);
      } else if (
        this.action &&
        this.ludwig.givesAfuck &&
        !this.ludwig.isFindingPath
      ) {
        this.positionLudwig();
        this.wait(50).then(() => {
          this.redraw();
          this.startAction();
        });
        //handle actions
      } else {
        this.ludwig.lookFront();
        this.wait(10).then(() => {
          this.redraw();
          //  this.ludwig.hint();
        });
      }
    },
    positionLudwig() {
      if (this.propPos[3] == 1) {
        if (this.propPos[2] >= this.ludwig.depth) {
          this.ludwig.lookFront();
        } else {
          this.ludwig.lookBack();
        }
      } else {
        if (this.propPos[0] < this.ludwig.pos[0]) {
          this.ludwig.lookRight();
        } else {
          this.ludwig.lookLeft();
        }
      }
    },
    redraw() {
      this.ctx.clearRect(0, 0, 1920, 1080);
      this.scene.draw();
      for (let prop of this.props) {
        //items behind Ludwig
        if (prop.depth <= this.ludwig.depth + this.ludwig.height) {
          this.drawProp(prop);
        }
      }
      this.ludwig.draw();
      for (let prop of this.props) {
        //items in front of Ludwig
        if (prop.depth > this.ludwig.depth + this.ludwig.height) {
          this.drawProp(prop);
        }
        //  prop.hint(this.ctx)
      }
    },
    wait(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    startAction() {
      this.$store.commit("resetCurrentLine", true);
      this.$root.$refs.private.startAction(this.action);
      if (!this.line) {
        this.$root.$refs.private.startNextAction(this.action);
      } else {
        this.$store.commit("waitForMo");
        document
          .getElementById("canvasOverlay")
          .classList.remove("clickthroug");
      }
      if (this.waitingForMo) {
        document
          .getElementById("canvasOverlay")
          .classList.remove("clickthroug");
      }
    },
    stopAnimation() {
      cancelAnimationFrame(this.ludwig.animation);
    },
    next() {
      if (this.waitingForMo && this.currentLine >= 0) {
        this.$root.$refs.private.startNextAction(this.action);
      } else if (this.$root.$refs.private.loading) {
        this.$root.$refs._dialogue.endAnswer();
        this.$root.$refs.private.continue();
      } else {
        this.$root.$refs.private.continue();
      }
      if (!this.waitingForMo) {
        document.getElementById("canvasOverlay").classList.add("clickthroug");
        this.ludwig.lookFront();
        this.wait(10).then(() => {
          this.redraw();
        });
      }
    },
  },

  beforeDestroy() {
    // Stoppe die Animation, wenn die Komponente zerstört wird
    this.stopAnimation();
  },
};
</script>

<style scoped lang="scss">
@import "../scss/_variables.scss";
canvas {
  //  border: 1px solid black;
  width: $width;
  height: $height;
}
.overlay {
  position: absolute;
  top: 0;
  width: $width;
  height: $height;
  z-index: 100;
  cursor: pointer;
}
.clickthroug {
  pointer-events: none;
}
.subtitles {
  text-align: center;
  position: absolute;
  width: $width;
  bottom: 30px;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  color: white;
  font-size: 3em;
}
</style>
